import "./spinner.css";

export function Spinner({ progress, text }) {
	const listki = 10;
	const newDiv = [];

	const createDiv = () => {
		for (let i = 1; i <= listki; i++) {
			newDiv.push(<div className={`listki listek${i}`} key={i}></div>);
		}
		return newDiv;
	};

	return (
		<>
			<div className="loading">
				<div className="divContainerSpiner">{createDiv()}</div>
				<div className="LoadingTextDiv">
					{!text && <p className="loadingText">Loading</p>}
					{progress && <p className="loadingProgress">{progress}%</p>}
					{text && <p className="loadingProgress">{text}</p>}
				</div>
			</div>
		</>
	);
}
